import React, { Component } from 'react'

export default class Login extends Component {
  render() {
    return (
      <div id="login-page" className="fullHeight clear relative">
        <section className="squad">
          <h2>Registre-se</h2>
          <div className="left">
            <form>
              <input type="email" placeholder="E-mail" required />
              <input type="password" placeholder="Senha" required />
              <button className="button primary-color">Entrar</button>
            </form>
          </div>
          <div className="right">
            <a href="" className="buttonSocial facebook">Registre-se com Facebook</a>
            <a href="" className="buttonSocial google">Registre-se com Google</a>
            <a href="" className="buttonSocial linkedin">Registre-se com Linkedin</a>
            <a href="#register" className="buttonSocial newRegister">Registrar sem redes sociais</a>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/login.js